import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChannelSearchDialogComponent } from '@components/channel-search-dialog/channel-search-dialog.component';
import { MoreOption, MoreOptionAction } from '@components/more-options/more-options-dropdown.component';
import { Channel } from 'icreate/common/models/channel';
import { ChannelType, getAnalogTypesSet } from 'icreate/common/models/channel-type';
import { Turbocharger } from 'icreate/common/models/graphs';
import _ from 'lodash';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-turbo-graph-table-row',
    templateUrl: './turbo-graph-table-row.component.html',
    styleUrl: './turbo-graph-table-row.component.css',
    standalone: false,
})
export class TurboGraphTableRowComponent {
    @Input() rowIndex: number;
    @Input() channel: Turbocharger;
    @Input() vesselId: string;
    @Input() optionsVisible: boolean;
    @Output() onDeleteRow: EventEmitter<void> = new EventEmitter<void>();
    @Output() onOptionsToggled: EventEmitter<number> = new EventEmitter<number>();

    @Output() onChannelUpdated: EventEmitter<void> = new EventEmitter<void>(); // Eklendi

    @ViewChild('otherOptions') otherOptions: ElementRef;
    @ViewChild('iconButton') iconButton: ElementRef;

    allowedTypesSet: Set<ChannelType> = getAnalogTypesSet();

    constructor(private dialog: MatDialog) {}

    @HostListener('document:click', ['$event'])
    clickOut(event: any) {
        if (
            this.otherOptions &&
            this.iconButton &&
            !this.otherOptions.nativeElement.contains(event.target) &&
            !this.iconButton.nativeElement.contains(event.target) &&
            this.optionsVisible
        ) {
            this.onOptionsToggled.emit(this.rowIndex);
        }
    }

    @HostListener('window:resize')
    onWindowChange() {
        if (this.optionsVisible) {
            this.onOptionsToggled.emit(this.rowIndex);
        }
    }

    async openChannelSelector() {
        const dialogRef = this.dialog.open(ChannelSearchDialogComponent, {
            data: {
                vesselId: this.vesselId,
                assignedChannel: this.channel.tempChannel,
                allowedTypesSet: this.allowedTypesSet,
                setShouldDisableTypes: true,
            },
        });
        const channelSelected: Channel = await lastValueFrom(dialogRef.afterClosed());
        if (channelSelected) {
            this.channel.tempChannel = channelSelected;
            this.onChannelUpdated.emit(); // Üst bileşene haber veriliyor
        }
    }

    removeChannel() {
        this.channel.tempChannel = null;
    }

    openOptions() {
        this.onOptionsToggled.emit(this.rowIndex);
    }

    clear() {
        if (this.clearIsDisabled()) return;
        this.channel.tempChannel = null;
        this.onOptionsToggled.emit(this.rowIndex);
    }

    deleteRow() {
        this.onDeleteRow.emit();
        this.onOptionsToggled.emit(this.rowIndex);
    }

    clearIsDisabled() {
        return !this.channel?.tempChannel;
    }

    get moreOptions(): MoreOption[] {
        return [
            {
                action: MoreOptionAction.CLEAR,
                string: 'dlg.clear',
                disabled: this.clearIsDisabled(),
            },
            {
                action: MoreOptionAction.DELETE,
                string: 'dlg.delete',
            },
        ];
    }

    onMoreOptionSelected(action: MoreOptionAction): void {
        switch (action) {
            case MoreOptionAction.CLEAR:
                this.clear();
                break;

            case MoreOptionAction.DELETE:
                this.deleteRow();
                break;
        }
    }
}
